import { useCallback, useState } from "react";
import { AsyncFunction } from "../types/hooks";

const useAsync = <T, A extends unknown[]>() => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<T | null>(null);

  const execute = useCallback(
    async (req: AsyncFunction<T, A>, ...args: A): Promise<T> => {
      setLoading(true);
      setError(null);
      setData(null);
      try {
        const res: T = await req(...args);
        setData(res);
        return res;
      } catch (err: unknown) {
        const errorMessage =
          err instanceof Error ? err.message : "An unknown error occurred";
        setError(errorMessage);
        throw new Error(errorMessage); 
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const reset = useCallback(() => {
    setLoading(false);
    setError(null);
    setData(null);
  }, []);

  return { loading, execute, error, data, reset };
};

export default useAsync;